// import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Pagination } from "@mui/material";
// import { Box } from "@mui/system";
// import { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router";
// import { Button } from "reactstrap";
// import { Grid } from "rsuite";
// import ShowLoader from "src/components/CustomComponents/ShowLoader";
// import TableCells from "src/components/Tables/TableCells";
// import SelectInputs from "src/components/inputs/SelectInputs";
// import TextInputs from "src/components/inputs/TextInputs";
// import { useMain } from "src/views/hooks/useMain";
// import { AiOutlineInfoCircle } from "react-icons/ai";
// // import { MdDelete } from "react-icons/md";
// import { FaRegEdit } from "react-icons/fa";
// import { FaEye } from "react-icons/fa";
// import { QurealCollection, useQurealActions } from "qureal-editor";
// import {
//     setLoading,
//     setUpdatedPackageData,
//     setSelectedPackage,
//     resetUpdatedPackageData,
//     updatePackageInState
// } from "../../../redux/slices/membershipSlice";
// import { useDispatch, useSelector } from "react-redux";

// const AllPackages = ({ data, branchData }) => {
//     const dispatch = useDispatch();
//     const {
//         updatedPackageData,
//         selectedPackageId,
//         loading
//     } = useSelector((state) => state.memberships);
//     const [openDialogue, setOpenDialogue] = useState(false);
//     const [openEyeDialog, setOpenEyeDialog] = useState(false);
//     const [selectedCardItem, setSelectedCardItem] = useState({});

//     const { actionRef, download, share } = useQurealActions()

//     const { activeBranchId, updatePackage, setShowMessage } =
//         useMain();


//     const navigate = useNavigate()
//     const { state } = useLocation()

//     const handleCloseDialogue = () => {
//         setOpenDialogue(false);
//         dispatch(resetUpdatedPackageData());
//     };

//     const handleEyeClick = (item) => {
//         setSelectedCardItem(item);
//         setOpenEyeDialog(true);
//     };

//     const handleCloseDialog = () => {
//         setOpenEyeDialog(false);
//     };

//     //   const handleInputChange = (e) => {
//     //     const { name, value } = e.target;
//     //     dispatch(setUpdatedPackageData({
//     //       field: name, 
//     //       value: name === 'packageDuration' ? Number(value) : value
//     //     }));
//     //   };
//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         let newValue = value;
//         if (name === 'packageDuration') {
//             newValue = value === '' ? '' : Number(value);
//         }

//         dispatch(setUpdatedPackageData({ field: name, value: newValue }));
//     };

//     const handleUpdate = (item) => {
//         setOpenDialogue(true)
//         dispatch(setSelectedPackage(item));
//     };


//     const hadleUpdatePackage = async () => {
//         try {
//             dispatch(setLoading(true));
//             //   const res = await updatePackage(
//             //     selectedPackageId,
//             //     updatedPackageData,
//             //     `?branchId=${activeBranchId}`,
//             //   );
//             const preparedData = {
//                 ...updatedPackageData,
//                 packageDuration: updatedPackageData.packageDuration === '' ? 0 : updatedPackageData.packageDuration
//             };

//             const res = await updatePackage(
//                 selectedPackageId,
//                 preparedData,
//                 `?branchId=${activeBranchId}`,
//             );

//             if (res.statusCode === 200) {
//                 setShowMessage({
//                     message: res.message || 'Package updated successfully',
//                     messageType: 'success',
//                 });

//                 // Update the package in Redux state
//                 dispatch(updatePackageInState({
//                     _id: selectedPackageId,
//                     ...updatedPackageData
//                 }));

//                 dispatch(resetUpdatedPackageData());
//                 handleCloseDialogue();
//             } else {
//                 setShowMessage({
//                     message: res.message || 'Failed to update package',
//                     messageType: 'error',
//                 });
//             }
//         } catch (error) {
//             setShowMessage({
//                 message: error.message || 'Something went wrong',
//                 messageType: 'error'
//             });
//         } finally {
//             dispatch(setLoading(false));
//         }
//     };


//     const handleDetails = (id) => {
//         navigate(`/packagedetail/${id}`, { state });
//     };

//     const buildContent = (services) => {
//         console.log(services, 'servicessss')
//         return services?.map(serviceObj => {
//             return `✶ ${serviceObj?.serviceName}`;
//         }).join('<br>');
//     }

//     const calculateTotalPrice = (services) => {
//         return services?.reduce((total, serviceObj) => {
//             return total + serviceObj.price;  // Add the price of each service to the total
//         }, 0);  // Start with an initial value of 0
//     };

//     const buildPriceComparison = (selectedCardItem) => {
//         // Get the total price of the services
//         const totalServicePrice = calculateTotalPrice(selectedCardItem?.services);
//         console.log(totalServicePrice, 'totalServicePrice');

//         // Compare the total service price with package price
//         const packagePrice = selectedCardItem?.price || 0;
//         console.log(packagePrice, 'packagePrice');

//         if (totalServicePrice > packagePrice) {
//             // Calculate percentage of savings
//             const discountPercentage = Math.round(((totalServicePrice - packagePrice) / totalServicePrice) * 100);

//             // If the total price of services is greater than the package price, show the discount message
//             return `
//                 <span style="text-decoration: line-through; color: black;">
//                     Rs ${totalServicePrice} 
//                 </span>
//                 <span style="font-weight: bold; color: green;">
//                     Rs ${packagePrice}
//                 </span>
//                 <span style="color: blue; font-size: 14px; margin-left: 5px;">
//                     (Save ${discountPercentage}% Amount on this package!)
//                 </span>
//             `;
//         } else {
//             // If no savings, just show the package price
//             return `Rs ${packagePrice}`;
//         }
//     };


//     return (
//         <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
//             <table className="table-container mt-3">
//                 <thead className="table-thead">
//                     <tr>
//                         {[
//                             'Package Name',
//                             'Package Price',
//                             'Package Validity(in Months)',
//                             'Actions',
//                         ].map((h, index) => {
//                             return (
//                                 <th key={index} style={{ width: '100%' }}>
//                                     {h}
//                                 </th>
//                             );
//                         })}
//                     </tr>
//                 </thead>
//                 <tbody className="table-tbody">
//                     {data.map((item) => {
//                         const originalDate = item?.validTill;

//                         // Convert "YYYY-MM-DD" to "DD-MM-YYYY"
//                         let formattedValidityDate = '';
//                         if (originalDate) {
//                             const [year, month, day] = originalDate.split('-');
//                             formattedValidityDate = `${day}-${month}-${year}`;
//                         }
//                         return (
//                             <tr key={item._id}>
//                                 <td style={{ width: '120%' }}>{item.packageName}</td>
//                                 <td style={{ width: '120%' }}>{item.price}</td>
//                                 <td style={{ width: '100%' }}>
//                                     {item.packageDuration ? item.packageDuration : formattedValidityDate}
//                                 </td>

//                                 {/* <td style={{ width: '100%' }}>
//                                     <TableCells
//                                         type="button"
//                                         handleDeleteField={""}
//                                         handleDetails={handleDetails}
//                                         handleUpdate={() => handleUpdate(item)}
//                                         field={item?._id}
//                                     />
//                                 </td> */}
//                                 <td style={{
//                                     width: '120%'
//                                 }}>
//                                     <IconButton onClick={() => handleDetails(item._id)} color="primary" title="View Details" style={{ marginRight: '-5px' }}>
//                                         <AiOutlineInfoCircle style={{ color: '#696969', fontSize: '1.1rem', marginLeft: '1.5rem' }} />
//                                     </IconButton>
//                                     <IconButton onClick={() => handleUpdate(item)} color="secondary" title="Update" style={{ marginRight: '24px' }}>
//                                         <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
//                                     </IconButton>
//                                     <IconButton onClick={() => handleEyeClick(item)} color="primary" title="View">
//                                         <FaEye color="black" style={{ fontSize: '1.2rem', marginTop: '1px', marginLeft: '20px' }} />
//                                     </IconButton>
//                                 </td>
//                             </tr>
//                         );
//                     })}
//                 </tbody>
//             </table>

//             {/* {Card-Membership} */}
//             <Dialog
//                 open={openEyeDialog}
//                 onClose={handleCloseDialog}
//                 maxWidth={false} // Disables default maxWidth handling
//                 PaperProps={{
//                     style: {
//                         width: "1100px", // Fixed width of the dialog
//                         height: "100vh", // Set height to 100vh
//                         margin: "auto", // Centers the dialog horizontally
//                         display: "flex", // Ensures the dialog content takes full height
//                         flexDirection: "column", // Aligns content in a column
//                         borderRadius: "10px", // Border radius for smooth corners
//                         padding: "10px", // Padding around the dialog (optional)
//                     },
//                 }}
//             >
//                 <DialogContent
//                     style={{
//                         display: "flex",
//                         flexDirection: "column",
//                         flexGrow: 1, // Ensures content fills the available space
//                         padding: "0", // No padding inside content
//                         backgroundColor: "white", // White background inside the content
//                         overflow: "hidden", // Prevents vertical scrollbars
//                     }}
//                 >
//                     {/* QurealCollection component */}
//                     {/* <QurealCollection
//                         collection_id="9ff9f448-3ce3-4d09-9bcc-4e5c4d763a9a"
//                         organization="your_salon_QBdXA"
//                         background="white" // White background for the collection
//                         style={{
//                             width: "100%", // Ensures the component fills the full width
//                             height: "100%", // Ensures the component fills the full height
//                             border: "1px solid black", // Border around the component
//                             borderRadius: "10px", // Rounded corners
//                             overflow: "hidden", // Prevents scrollbars inside the component
//                         }}
//                         actionRef={actionRef}
//                         preview={true}
//                         prefill={{
//                             discount_offer_with_body: {
//                                 offer_name: selectedCardItem.packageName,
//                                 offer_price: `RS ${selectedCardItem.price}`,
//                                 validity: selectedCardItem?.validTill
//                                 ? `Valid for ${new Date(selectedCardItem.validTill).toLocaleDateString()}`
//                                 : `Valid for ${selectedCardItem?.packageDuration || 0} Months`,

//                                 content: buildContent(selectedCardItem?.services),
//                                 extra: `${buildPriceComparison(selectedCardItem)}`
//                             },
//                             ai_model: {
//                                 model: "e9c8b5c4-4a2f-4c15-85a4-a57669a00999",
//                             },
//                         }}
//                     /> */}
//                     <QurealCollection
//                         collection_id="9ff9f448-3ce3-4d09-9bcc-4e5c4d763a9a"
//                         organization="your_salon_QBdXA"
//                         background="white" // White background for the collection
//                         style={{
//                             width: "100%", // Ensures the component fills the full width
//                             height: "100%", // Ensures the component fills the full height
//                             border: "1px solid black", // Border around the component
//                             borderRadius: "10px", // Rounded corners
//                             overflow: "hidden", // Prevents scrollbars inside the component
//                         }}
//                         actionRef={actionRef}
//                         preview={true}
//                         prefill={{
//                             discount_offer_with_body: {
//                                 offer_name: selectedCardItem.packageName,
//                                 offer_price: `RS ${selectedCardItem.price}`,
//                                 validity: selectedCardItem?.validTill
//                                     ? `Valid for ${new Date(selectedCardItem.validTill).toLocaleDateString()}`
//                                     : `Valid for ${selectedCardItem?.packageDuration || 0} Months`,

//                                 content: buildContent(selectedCardItem?.services),
//                                 extra: `${buildPriceComparison(selectedCardItem)}`
//                             },
//                             ai_model: {
//                                 model: "e9c8b5c4-4a2f-4c15-85a4-a57669a00999",
//                             },
//                             current_organization: {
//                                 name: branchData?.branchName || "",
//                                 primary_phone: branchData?.branchPhone,
//                                 primary_email: branchData?.branchEmail || "",
//                                 address: branchData?.address,
//                                 website: branchData?.branchName,
//                                 logo: {
//                                     value: branchData?.logo?.url,
//                                 },
//                                 logo_dark: {
//                                     value: branchData?.logo?.url,
//                                 },
//                                 logo_square: {
//                                     value: branchData?.logo?.url,
//                                 }
//                             }
//                         }}
//                     />
//                 </DialogContent>

//                 <DialogActions
//                     style={{
//                         display: "flex",
//                         justifyContent: "flex-end", // Align buttons to the right
//                         padding: "16px", // Padding for buttons
//                         backgroundColor: "#f5f5f5", // Optional: light grey background for the button section
//                     }}
//                 >
//                     <Button
//                         onClick={handleCloseDialog}
//                         color="primary"
//                         style={{
//                             marginRight: "10px", // Space between buttons
//                         }}
//                     >
//                         Close
//                     </Button>

//                     <Button
//                         variant="contained"
//                         color="primary"
//                         sx={{
//                             background: '#6174DD',
//                             marginRight: "10px", // Space between buttons
//                         }}
//                         onClick={share}
//                     >
//                         Share
//                     </Button>

//                     <Button
//                         variant="contained"
//                         color="primary"
//                         sx={{
//                             background: '#6174DD',
//                         }}
//                         onClick={download}
//                     >
//                         Download
//                     </Button>
//                 </DialogActions>
//             </Dialog>


//             <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md">
//                 <DialogTitle> Package Details</DialogTitle>
//                 <DialogContent>
//                     <DialogContentText>Here you can update Package details.</DialogContentText>
//                     <Box style={{ marginTop: '20px' }}>
//                         <Grid container spacing={4}>
//                             <Grid item xs={12} md={3}>
//                                 <TextInputs
//                                     title={'Package Name'}
//                                     name={'packageName'}
//                                     value={updatedPackageData?.packageName}
//                                     handleChange={handleInputChange}
//                                     type={'text'}
//                                     required={false}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={3}>
//                                 <TextInputs
//                                     title={'Package Price'}
//                                     name={'price'}
//                                     value={updatedPackageData?.price}
//                                     handleChange={handleInputChange}
//                                     type={'number'}
//                                     required={false}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={3}>
//                                 <TextInputs
//                                     title={'Duration (in Months)'}
//                                     name={'packageDuration'}
//                                     value={updatedPackageData?.packageDuration === '' ? '' : updatedPackageData?.packageDuration}
//                                     handleChange={handleInputChange}
//                                     type={'number'}
//                                     min={new Date().toISOString().split('T')[0]}
//                                 // fieldValidation={validTillValidation && formValidation.validTillValidation}
//                                 />
//                             </Grid>

//                         </Grid>
//                     </Box>
//                 </DialogContent>
//                 <DialogActions>
//                     {loading ? (
//                         <ShowLoader />
//                     ) : (
//                         <>
//                             {/* <div style={{ width: '200px', margin: '3rem auto' }}> */}
//                             <div style={{ margin: '3rem auto' }}>
//                                 <Button
//                                     variant="contained"
//                                     fullWidth
//                                     color="primary"
//                                     target="_blank"
//                                     sx={{
//                                         background: '#6174DD',
//                                     }}
//                                     onClick={handleCloseDialogue}
//                                 >
//                                     Cancel
//                                 </Button>
//                             </div>
//                             <div style={{ margin: '3rem auto' }}>
//                                 <Button
//                                     variant="contained"
//                                     fullWidth
//                                     color="primary"
//                                     target="_blank"
//                                     sx={{
//                                         background: '#6174DD',
//                                     }}
//                                     onClick={hadleUpdatePackage}
//                                 >
//                                     update
//                                 </Button>
//                             </div>
//                         </>
//                     )}
//                 </DialogActions>
//             </Dialog>
//         </Box>
//     )
// }

// export default AllPackages

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Pagination, Typography,CircularProgress , FormControl, Select, MenuItem  } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router";
import { Button } from "reactstrap";
import { Grid } from "rsuite";
import ShowLoader from "src/components/CustomComponents/ShowLoader";
import TableCells from "src/components/Tables/TableCells";
import SelectInputs from "src/components/inputs/SelectInputs";
import TextInputs from "src/components/inputs/TextInputs";
import { useMain } from "src/views/hooks/useMain";
import { AiOutlineInfoCircle } from "react-icons/ai";
// import { MdDelete } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { QurealCollection, useQurealActions } from "qureal-editor";
import {
    setLoading,
    setUpdatedPackageData,
    setSelectedPackage,
    resetUpdatedPackageData,
    updatePackageInState,
    removePackageFromState
} from "../../../redux/slices/membershipSlice";
import { useDispatch, useSelector } from "react-redux";
import { MdDelete } from "react-icons/md";
import { getHighlightedText } from 'src/utils/textUtils';

const taxStatusOptions = [
     { value: 'withTax', label: 'Inclusive (5% GST)' },
    { value: 'withoutTax', label: 'Exclusive (5% GST)' },
    // { value: 'noGst', label: 'No GST' },
];

const AllPackages = ({ data, branchData, search }) => {
    const packageGridTemplate = '220px 120px 130px 200px';
        const packageGridRowStyle = {
        display: 'grid',
        gridTemplateColumns: packageGridTemplate,
        alignItems: 'center',
        columnGap: '10px',
    };
    const dispatch = useDispatch();
    const {
        updatedPackageData,
        selectedPackageId,
        loading
    } = useSelector((state) => state.memberships);
const isGstRequired = !!(branchData?.gstNumber && branchData.gstNumber.trim().length > 0);

      const taxableValue = useMemo(() => {
        const p = Number(updatedPackageData?.price) || 0;
         if (!isGstRequired) {
      return p.toFixed(2);
    }
        if (updatedPackageData?.taxStatus === 'withTax') {
            return (p / 1.05).toFixed(2);
        }
        return p.toFixed(2);
    }, [updatedPackageData?.price, updatedPackageData?.taxStatus, isGstRequired]);
    const [openEyeDialog, setOpenEyeDialog] = useState(false);
    const [selectedCardItem, setSelectedCardItem] = useState({});
    const [openDialogue, setOpenDialogue] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteId, setDeleteId] = useState(null)
    const [deleteLoading, setDeleteLoading] = useState(false);
    // const [loading, setLoading] = useState(false);


    const { actionRef, download, share } = useQurealActions()

    const { activeBranchId, updatePackage, deletePackages, setShowMessage } =
        useMain();

    const navigate = useNavigate()
    const { state } = useLocation()

    const handleCloseDialogue = () => {
        setOpenDialogue(false);
        dispatch(resetUpdatedPackageData());
    };

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setUpdateFormData((pre) => ({ ...pre, [name]: value }));
    // };
    const handleEyeClick = (item) => {
        setSelectedCardItem(item);
        setOpenEyeDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenEyeDialog(false);
    };

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     dispatch(setUpdatedPackageData({
    //       field: name, 
    //       value: name === 'packageDuration' ? Number(value) : value
    //     }));
    //   };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;

        if (name === 'packageDuration') {
            newValue = value === '' ? '' : Number(value);
            dispatch(setUpdatedPackageData({ field: 'durationType', value: 'duration' }));
        }

        if (name === 'validTill') {
            dispatch(setUpdatedPackageData({ field: 'durationType', value: 'validTill' }));
        }

        dispatch(setUpdatedPackageData({ field: name, value: newValue }));
    };



    const handleUpdate = (item) => {
        console.log(item, 'Package item for update');

        // Keep the original data intact
        const dataToUpdate = { ...item };

        // Identify type
        if (item.packageDuration) {
            dataToUpdate.durationType = 'duration';
        } else if (item.validTill) {
            dataToUpdate.durationType = 'validTill';
        }

        // ✅ Ensure services are passed properly
        dataToUpdate.services = item.services || [];

        setOpenDialogue(true);
        dispatch(setSelectedPackage(dataToUpdate));
    };



    const handleUpdatePackage = async () => {
        try {
            dispatch(setLoading(true));

            // ✅ Prepare clean data
            let preparedData = {
                ...updatedPackageData,
                price: Number(updatedPackageData.price),
                                taxStatus: updatedPackageData.taxStatus,
                                
                taxableValue: taxableValue,
                packageDuration:
                    updatedPackageData.packageDuration === ''
                        ? 0
                        : Number(updatedPackageData.packageDuration),
            };
            
            delete preparedData.gst;


            // ✅ Handle duration-validTill logic (same as membership)
            if (preparedData.packageDuration) {
                delete preparedData.validTill;
            } else if (preparedData.validTill) {
                delete preparedData.packageDuration;
            }

            if (!preparedData.packageDuration && !preparedData.validTill) {
                setShowMessage({
                    message: 'Please provide either Duration or Valid Till date',
                    messageType: 'error',
                });
                dispatch(setLoading(false));
                return;
            }


            // ✅ Send API request
            const res = await updatePackage(
                selectedPackageId,
                preparedData,
                `?branchId=${activeBranchId}`
            );

            if (res.statusCode === 200) {
                setShowMessage({
                    message: res.message || 'Package updated successfully',
                    messageType: 'success',
                });

                // ✅ Update in Redux store
                dispatch(
                    updatePackageInState({
                        _id: selectedPackageId,
                        ...preparedData,
                    })
                );

                dispatch(resetUpdatedPackageData());
                handleCloseDialogue();
            } else {
                setShowMessage({
                    message: res.message || 'Failed to update package',
                    messageType: 'error',
                });
            }
        } catch (error) {
            setShowMessage({
                message: error.message || 'Something went wrong',
                messageType: 'error',
            });
        } finally {
            dispatch(setLoading(false));
        }
    };


    const handleDetails = (id) => {
        navigate(`/packagedetail/${id}`, { state });
    };

    const handleDeleteField = (id) => {
        setDeleteId(id);
        setOpenDeleteDialog(true);
    };

    const confirmDelete = async () => {
        setDeleteLoading(true);
        try {
            const res = await deletePackages(deleteId, `?branchId=${activeBranchId}`);
            if (res?.statusCode === 200) {
                setShowMessage({
                    message: res.message || 'Package deleted successfully',
                    messageType: 'success',
                });

                dispatch(removePackageFromState(deleteId));
            } else {
                setShowMessage({
                    message: res.message || 'Package not deleted',
                    messageType: 'error',
                });
            }
        } catch (error) {
            setShowMessage({
                message: error.message || 'Something went wrong',
                messageType: 'error',
            });
        } finally {
            setOpenDeleteDialog(false);
            setDeleteId(null);
            setDeleteLoading(false);
        }
    };

    const handleCloseDeleteDialog = () => {
        setOpenDeleteDialog(false);
        setDeleteId(null);
    };

    const buildContent = (services) => {
        console.log(services, 'servicessss')
        return services?.map(serviceObj => {
            return `✶ ${serviceObj?.serviceName}`;
        }).join('<br>');
    }

    const calculateTotalPrice = (services) => {
        return services?.reduce((total, serviceObj) => {
            return total + serviceObj.price;  // Add the price of each service to the total
        }, 0);  // Start with an initial value of 0
    };


    const buildPriceComparison = (selectedCardItem) => {
        // Get the total price of the services
        const totalServicePrice = calculateTotalPrice(selectedCardItem?.services);
        console.log(totalServicePrice, 'totalServicePrice');

        // Compare the total service price with package price
        const packagePrice = selectedCardItem?.price || 0;

        if (totalServicePrice > packagePrice) {
            // Calculate percentage of savings
            const discountPercentage = Math.round(((totalServicePrice - packagePrice) / totalServicePrice) * 100);

            // If the total price of services is greater than the package price, show the discount message
            return encodeURIComponent(`
                <span style='text-decoration: line-through; color: black;'>
                    Rs ${totalServicePrice} 
                </span>
                <span style='font-weight: bold; color: green;'>
                    Rs ${packagePrice}
                </span>
                <span style='color: blue; font-size: 14px; margin-left: 5px;'>
                    (Save ${discountPercentage}% Amount on this package!)
                </span>
            `)
        } else {
            // If no savings, just show the package price
            return `Rs ${packagePrice}`;
        }
    };

    // console.log(buildPriceComparison(selectedCardItem),'extraaa')
    return (
        <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
            <table className="table-container mt-3">
                <thead className="table-thead">
                    <tr style={packageGridRowStyle}>
                        <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>Package Name</th>
                        <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>Package Price</th>
                        <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>Package Duration</th>
                        <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>Actions</th>
                    </tr>
                </thead>
                <tbody className="table-tbody">
                    {data.map((item) => {
                        const originalDate = item?.validTill;

                        // Convert "YYYY-MM-DD" to "DD-MM-YYYY"
                        let formattedValidityDate = '';
                        if (originalDate) {
                            const [year, month, day] = originalDate.split('-');
                            formattedValidityDate = `${day}-${month}-${year}`;
                        }
                     return (
                            <tr key={item._id} style={packageGridRowStyle}>
                                <td style={{ textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {getHighlightedText(item.packageName, search)}
                            </td>                                
                            <td style={{ textAlign: 'center' }}>{item.price}</td>
                                <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                                    {item.packageDuration ? `${item.packageDuration} Month` : formattedValidityDate}
                                </td>


                                {/* <td style={{
                                    width: '116%'
                                }}>
                                    <IconButton onClick={() => handleDetails(item._id)} color="primary" title="View Details" style={{ marginRight: '-5px' }}>
                                        <AiOutlineInfoCircle style={{ color: '#696969', fontSize: '1.1rem', marginLeft: '1.8rem' }} />
                                    </IconButton>
                                    <IconButton onClick={() => handleDeleteField(item._id)} color="error" title="Delete" style={{ marginLeft: '-33px' }}>
                                        <MdDelete color='#FF4D4D' style={{ fontSize: '1.2rem',  marginLeft: '1.8rem' }} />
                                    </IconButton>
                                    <IconButton onClick={() => handleUpdate(item)} color="secondary" title="Update" style={{ marginRight: '24px' }}>
                                        <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
                                    </IconButton>
                                    <IconButton onClick={() => handleEyeClick(item)} color="primary" title="View">
                                        <FaEye color="black" style={{ fontSize: '1.2rem', marginTop: '1px', marginLeft: '20px' }} />
                                    </IconButton>
                                </td> */}
                               <td>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px', // Equal spacing between all icons
                                        }}
                                    >
                                        <IconButton
                                            onClick={() => handleDetails(item._id)}
                                            color="primary"
                                            title="View Details"
                                        >
                                            <AiOutlineInfoCircle style={{ color: '#696969', fontSize: '1.1rem' }} />
                                        </IconButton>

                                        <IconButton
                                            onClick={() => handleDeleteField(item._id)}
                                            color="error"
                                            title="Delete"
                                        >
                                            <MdDelete color="#FF4D4D" style={{ fontSize: '1.2rem' }} />
                                        </IconButton>

                                        <IconButton
                                            onClick={() => handleUpdate(item)}
                                            color="secondary"
                                            title="Update"
                                        >
                                            <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
                                        </IconButton>

                                        <IconButton
                                            onClick={() => handleEyeClick(item)}
                                            color="primary"
                                            title="View"
                                        >
                                            <FaEye color="black" style={{ fontSize: '1.2rem' }} />
                                        </IconButton>
                                    </div>
                                </td>

                            </tr>
                        );
                    })}
                </tbody>
            </table>

            {/* delete-package */}
            <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
                <DialogContent>
                    Are you sure you want to delete this Package?
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDeleteDialog} color="primary">Cancel</Button>
                          <Button
                     onClick={confirmDelete} 
                     color="secondary"
                     >
                            {deleteLoading ? (
                                      <CircularProgress size={18} style={{ color: 'white' }} />
                                    ) :
                                      'Delete'
                            }
                        
                   </Button>
                </DialogActions>
            </Dialog>

            {/* {Card-Membership} */}
            <Dialog
                open={openEyeDialog}
                onClose={handleCloseDialog}
                maxWidth={false} // Disables default maxWidth handling
                PaperProps={{
                    style: {
                        width: "1100px", // Fixed width of the dialog
                        height: "100vh", // Set height to 100vh
                        margin: "auto", // Centers the dialog horizontally
                        display: "flex", // Ensures the dialog content takes full height
                        flexDirection: "column", // Aligns content in a column
                        borderRadius: "10px", // Border radius for smooth corners
                        padding: "10px", // Padding around the dialog (optional)
                    },
                }}
            >
                <DialogContent
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1, // Ensures content fills the available space
                        padding: "0", // No padding inside content
                        backgroundColor: "white", // White background inside the content
                        overflow: "hidden", // Prevents vertical scrollbars
                    }}
                >

                    <QurealCollection
                        collection_id="9ff9f448-3ce3-4d09-9bcc-4e5c4d763a9a"
                        organization="your_salon_QBdXA"
                        background="white" // White background for the collection
                        style={{
                            width: "100%", // Ensures the component fills the full width
                            height: "100%", // Ensures the component fills the full height
                            border: "1px solid black", // Border around the component
                            borderRadius: "10px", // Rounded corners
                            overflow: "hidden", // Prevents scrollbars inside the component
                        }}
                        actionRef={actionRef}
                        preview={true}
                        prefill={{
                            discount_offer_with_body: {
                                offer_name: selectedCardItem.packageName,
                                offer_price: `RS ${selectedCardItem.price}`,
                                validity: selectedCardItem?.validTill
                                    ? `Valid for ${new Date(selectedCardItem.validTill).toLocaleDateString()}`
                                    : `Valid for ${selectedCardItem?.packageDuration || 0} Months`,

                                content: buildContent(selectedCardItem?.services),
                                extra: `${buildPriceComparison(selectedCardItem)}`
                            },
                            ai_model: {
                                model: "e9c8b5c4-4a2f-4c15-85a4-a57669a00999",
                            },
                            current_organization: {
                                name: branchData?.branchName || "",
                                primary_phone: branchData?.branchPhone,
                                primary_email: branchData?.branchEmail || "",
                                address: branchData?.address,
                                website: branchData?.branchName,
                                logo: {
                                    value: branchData?.logo?.url,
                                },
                                logo_dark: {
                                    value: branchData?.logo?.url,
                                },
                                logo_square: {
                                    value: branchData?.logo?.url,
                                }
                            }
                        }}
                    />
                </DialogContent>

                <DialogActions
                    style={{
                        display: "flex",
                        justifyContent: "flex-end", // Align buttons to the right
                        padding: "16px", // Padding for buttons
                        backgroundColor: "#f5f5f5", // Optional: light grey background for the button section
                    }}
                >
                    <Button
                        onClick={handleCloseDialog}
                        color="primary"
                        style={{
                            marginRight: "10px", // Space between buttons
                        }}
                    >
                        Close
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            background: '#6174DD',
                            marginRight: "10px", // Space between buttons
                        }}
                        onClick={share}
                    >
                        Share
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            background: '#6174DD',
                        }}
                        onClick={download}
                    >
                        Download
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={openDialogue}
                onClose={handleCloseDialogue}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    sx: {
                        width: '450px',
                        maxWidth: '450px'
                    }
                }}
            >
                <DialogTitle>Package Details</DialogTitle>
                <DialogContent>
                    <DialogContentText>Here you can update Package details.</DialogContentText>

                   {/* First Row: Package Name */}
                    <Box sx={{ mt: 3 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextInputs
                                    title={'Package Name'}
                                    name={'packageName'}
                                    value={updatedPackageData?.packageName}
                                    handleChange={handleInputChange}
                                    type={'text'}
                                    required={false}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </Box>

                    {/* Second Row: Duration / Valid Till + Combined Price & Tax  */}
                    <Box sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            {updatedPackageData?.durationType === 'duration' && (
                                <Grid item xs={12}>
                                    <TextInputs
                                        required={false}
                                        title={'Duration (in Months)'}
                                        name={'packageDuration'}
                                        min={'1'}
                                        value={updatedPackageData?.packageDuration}
                                        handleChange={handleInputChange}
                                        type={'number'}
                                        fullWidth
                                    />
                                </Grid>
                            )}

                            {updatedPackageData?.durationType === 'validTill' && (
                                <Grid item xs={12}>
                                    <TextInputs
                                        required={false}
                                        title={'Valid Till Date'}
                                        name={'validTill'}
                                        value={updatedPackageData?.validTill}
                                        handleChange={handleInputChange}
                                        type={'date'}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                            )}

                            {/* Combined Package Price + Tax Status + Taxable Value */}
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <label style={{
                                        fontSize: "15px",
                                        fontWeight: 600,
                                        marginBottom: "8px",
                                        display: "inline-block",
                                        color: "#212529"
                                    }}>Package Price</label>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            border: '1px solid #ced4da',
                                            borderRadius: '4px',
                                            height: "57px",
                                            transition: 'border-color 0.2s ease-in-out',
                                            '&:hover': {
                                                borderColor: '#6174DD',
                                            },
                                        }}
                                    >
                                        <span style={{ padding: '0px 8px', fontSize: '16px', color: '#666' }}>₹</span>
                                        <input
                                            name="price"
                                            placeholder="0"
                                            value={updatedPackageData?.price}
                                            onChange={handleInputChange}
                                            type="number"
                                            min="0"
                                            style={{
                                                border: 'none',
                                                outline: 'none',
                                                flex: 1,
                                                padding: '12px 0px',
                                                fontSize: '16px',
                                                background: 'transparent',
                                                width: '100%'
                                            }}
                                        />
                                        {isGstRequired && (
                                            <Select
                                                name="taxStatus"
                                                value={updatedPackageData?.taxStatus || 'noGst'}
                                                onChange={handleInputChange}
                                                displayEmpty
                                                inputProps={{ 'aria-label': 'Without label' }}
                                                sx={{
                                                    background: '#F0F0F0',
                                                    border: 'none',
                                                    height: '100%',
                                                    borderTopLeftRadius: '0px',
                                                    borderBottomLeftRadius: '0px',
                                                    borderTopRightRadius: '3px',
                                                    borderBottomRightRadius: '3px',
                                                    '& .MuiSelect-select': {
                                                        padding: '8px 16px',
                                                        paddingRight: '24px !important',
                                                        height: '100% !important',
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    },
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none'
                                                    },
                                                    '&:hover': {
                                                        background: '#e0e0e0',
                                                    },
                                                    '&.Mui-focused': {
                                                        background: '#e0e0e0',
                                                    },
                                                    borderLeft: '1px solid #ced4da'
                                                }}
                                            >
                                                {taxStatusOptions.map(option => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    </Box>
                                    {isGstRequired && (
                                        <Box sx={{
                                            p: '8px 12px',
                                            backgroundColor: '#e9ecef',
                                            border: '1px solid #ced4da',
                                            borderTop: 'none',
                                            borderRadius: '0 0 4px 4px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}>
                                            <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>Taxable Value: {taxableValue}</span>
                                        </Box>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>

                    {/* Services Display Section */}
                    {updatedPackageData?.services && updatedPackageData.services.length > 0 && (
                        <Box sx={{
                            mt: 3,
                            p: 2,
                            backgroundColor: '#f8f9fa',
                            borderRadius: 1,
                            border: '1px solid #e0e0e0',
                            maxHeight: '200px',
                            overflow: 'auto'
                        }}>
                            <Typography variant="h6" gutterBottom sx={{ fontSize: '16px', fontWeight: 'bold' }}>
                                Included Services ({updatedPackageData.services.length})
                            </Typography>
                            <Box sx={{ maxHeight: '120px', overflow: 'auto' }}>
                                {updatedPackageData.services.map((service, index) => (
                                    <Box key={index} sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        py: 1,
                                        px: 1,
                                        borderBottom: index < updatedPackageData.services.length - 1 ? '1px solid #dee2e6' : 'none',
                                        backgroundColor: 'white',
                                        borderRadius: '4px',
                                        mb: 1
                                    }}>
                                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                                            {service.serviceName}
                                        </Typography>
                                        <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '14px' }}>
                                            ₹{service.price}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    )}
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                    {loading ? (
                        <ShowLoader />
                    ) : (
                        <>
                            <Button
                                variant="outlined"
                                color="primary"
                                sx={{
                                    minWidth: '100px',
                                }}
                                onClick={handleCloseDialogue}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                sx={{
                                    background: '#6174DD',
                                    minWidth: '100px',
                                }}
                                onClick={handleUpdatePackage}
                            >
                                Update
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default AllPackages
